import { createAction } from '@reduxjs/toolkit';
import { TwsData } from '../../utils/types';

export const connect = createAction<string, 'USER_SOCKET_CONNECT'>(
    'USER_SOCKET_CONNECT'
);
export const disconnect = createAction('USER_SOCKET_DISCONNECT');
export const wsConnecting = createAction('USER_SOCKET_CONNECTING');
export const wsOpen = createAction('USER_SOCKET_OPEN');
export const wsClose = createAction('USER_SOCKET_CLOSE');
export const wsMessage = createAction<TwsData, 'USER_SOCKET_MESSAGE'>(
    'USER_SOCKET_MESSAGE'
);
export const wsError = createAction<string, 'USER_SOCKET_ERROR'>(
    'USER_SOCKET_ERROR'
);

export type TSocketUserActions =
    | ReturnType<typeof connect>
    | ReturnType<typeof disconnect>
    | ReturnType<typeof wsConnecting>
    | ReturnType<typeof wsOpen>
    | ReturnType<typeof wsClose>
    | ReturnType<typeof wsMessage>
    | ReturnType<typeof wsError>;
